import { convertTimesheetToLocalDate } from '../funnel/funnelUtils'
import { OPEN, APPROVED } from '../../constants/timesheetStatus'
import { logError } from '../../utils/logger'

import * as timesheetService from '../../entities/timesheet/service'
import queryClient from '../../queryClient'
import { TIMESHEETS_QUERY_KEY } from '../../hooks/queries/keys'
import useTimesheetsStore from '../../stores/timesheetsStore'

export const submitTimesheet = async ({ client, timesheet, selectedDelegateId }) => {
  try {
    const updatedTimesheet = await timesheetService.updateTimesheetApprovalStatus({
      client,
      repliconId: timesheet.repliconId,
      approvalStatus: APPROVED,
      selectedDelegateId,
    })

    const [transformedTimesheet] = convertTimesheetToLocalDate([updatedTimesheet])
    useTimesheetsStore.getState().updateTimesheetInStore(transformedTimesheet)
    await queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY })
    return transformedTimesheet
  } catch (e) {
    logError(e, 'actions > timesheetAction > submitTimesheet > e: ')
    throw e
  }
}

export const reopenTimesheet = async ({ client, timesheet, selectedDelegateId }) => {
  try {
    const updatedTimesheet = await timesheetService.updateTimesheetApprovalStatus({
      client,
      repliconId: timesheet.repliconId,
      approvalStatus: OPEN,
      selectedDelegateId,
    })

    const [transformedTimesheet] = convertTimesheetToLocalDate([updatedTimesheet])
    useTimesheetsStore.getState().updateTimesheetInStore(transformedTimesheet)
    await queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY })
    return transformedTimesheet
  } catch (e) {
    logError(e, 'actions > timesheetAction > reopenTimesheet > e: ')
    throw e
  }
}

export const updateTimesheetApproveState = async ({ client, variables }) => {
  try {
    const updatedTimesheet = await timesheetService.updateTimesheetApproveStateService({
      client,
      variables,
    })
    const [transformedTimesheet] = convertTimesheetToLocalDate([updatedTimesheet])
    const newTimesheetData = { ...transformedTimesheet, approveState: { status: variables.state } }
    useTimesheetsStore.getState().updateTimesheetInStore(newTimesheetData)
    await queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY })
    return newTimesheetData
  } catch (e) {
    logError(e, 'actions > timesheetAction > updateTimesheetApproveState > e: ')
  }
}
